"use client"

import { useCallback } from "react"
import { useGlobalDialogStore } from "@/stores/use-global-dialog-store"

import { BulkEmailComposeDialog } from "./compose-dialog"

export interface RecipientIdentifier {
  type: "household" | "contact" | "person"
  id: string
}

interface UseBulkEmailComposeOptions {
  onSent?: () => void
}

export function useBulkEmailCompose(options?: UseBulkEmailComposeOptions) {
  const { openDialog, closeDialog } = useGlobalDialogStore()

  const open = useCallback(
    (recipientIds: RecipientIdentifier[]) => {
      openDialog({
        variant: "custom",
        content: <BulkEmailComposeDialog recipientIds={recipientIds} onClose={closeDialog} onSent={options?.onSent} />,
        dialogContentClasses: "max-w-[min(100vw-2rem,64rem)] p-0",
      })
    },
    [openDialog, closeDialog, options?.onSent]
  )

  return { open, close: closeDialog }
}
